define('views/modules/profile/edit/preferences-edit-panel-business',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/panel/base-panel',
    'views/modules/profile/edit/preferences-edit-content-business',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VPreferencesEditContentBusiness
) {

    var VPreferencesPanelBusiness = VBasePanel.extend({
        header: {
            title: "Preferences",
            subtitle: "Edit your preferences",
        },
        tabs: [{ id: 'preferences', title: 'Preferences', active: true }],
        content: {
            preferences: VPreferencesEditContentBusiness
        },
        defaultView: 'preferences',
        initialize: function(opt) {
            var preferences = this.getView('preferences', {
                model: this.model,
                group: opt.group
            });
            this.listenTo(preferences, { 'form:success': this.close });
        },

    });

    return VPreferencesPanelBusiness;
});

